import React from 'react';
import { Route } from 'react-router-dom';

export const MakeRoutesWithSubRoutes = (route) => {
  return (
    <Route 
      path={route.path}
      render={props => {
        return (
          <route.component {...props} routes={route.routes} />
        );
      }
      }
    />
  );
};



// WEBPACK FOOTER //
// ./src/MakeRoutesWithSubRoutes.js